import Marquee from "react-fast-marquee";
import { Sparkle } from "lucide-react";
import { MARQUEE_ITEMS } from "../data/content";

export default function EditorialMarquee() {
  return (
    <div
      data-testid="editorial-marquee"
      className="overflow-hidden border-y border-blue-100 bg-white py-8"
    >
      <Marquee speed={28} gradient={false} pauseOnHover>
        {MARQUEE_ITEMS.map((t, i) => (
          <span key={i} className="mx-8 flex items-center gap-16">
            <span
              className={`marquee-item text-4xl md:text-5xl ${
                i % 2 === 0 ? "text-fv-navy" : "text-outline-navy"
              }`}
            >
              {t}
            </span>
            <Sparkle className="h-6 w-6 fill-fv-blue text-fv-blue" />
          </span>
        ))}
      </Marquee>
    </div>
  );
}
